import { RootState } from "../../../app/store";
import { fnyfsName, fnyfsProviderId } from "../constants";
import { AccessLevelEnum } from "../enums/AccessLevelEnum";
import { PermissionResourceNameEnum } from "../enums/PermissionResourceNameEnum";

export const selectIsLoggedIn = (state: RootState) => {
  // TODO: Add additional logic for checking expirey time
  const { token } = state.authentication;

  if (token === null) return false;

  return true;
};

export const selectAuthenticationIsLoading = (state: RootState) =>
  state.authentication.isLoading;

export const selectUser = (state: RootState) => state.authentication.user;

export const selectIsExpired = (state: RootState) =>
  state.authentication.expiration
    ? state.authentication.expiration < Date.now() / 1000
    : undefined;

export const selectSelectedProviderId = (state: RootState) =>
  state.authentication.selectedProviderId;

export const selectPermissions = (state: RootState) =>
  state.authentication.permissions;

export const selectAuthenticationInitialzed = (state: RootState) =>
  state.authentication.initialized;

export const selectSelectedProviderName = (state: RootState) => {
  const providerId = state.authentication.selectedProviderId;
  if (providerId === fnyfsProviderId) return fnyfsName;
  if (providerId !== null)
    return state.authentication.permissions[providerId]?.name;

  return "";
};
export const selectHasMultipleProviderPermissions = (state: RootState) =>
  Object.keys(state.authentication.permissions).length > 1;

export const selectHasAccess =
  (name: PermissionResourceNameEnum, accessLevel: AccessLevelEnum) =>
  (state: RootState) => {
    const { permissions, selectedProviderId } = state.authentication;
    if (selectedProviderId == null || permissions == null) return false;

    const providerPermissions = permissions[selectedProviderId];
    const permission = providerPermissions?.permissions?.find(
      (x) => x.name === name
    );

    return permission !== undefined && permission.accessLevel >= accessLevel;
  };

export const selectHasReadAccess =
  (name: PermissionResourceNameEnum) => (state: RootState) =>
    selectHasAccess(name, AccessLevelEnum.Read)(state);

export const selectHasWriteAccess =
  (name: PermissionResourceNameEnum) => (state: RootState) =>
    selectHasAccess(name, AccessLevelEnum.Write)(state);

export const selectHasDeleteAccess =
  (name: PermissionResourceNameEnum) => (state: RootState) =>
    selectHasAccess(name, AccessLevelEnum.Delete)(state);

export const selectHasExecuteAccess =
  (name: PermissionResourceNameEnum) => (state: RootState) =>
    selectHasAccess(name, AccessLevelEnum.Execute)(state);
